import React from "react"
import { ThemeProvider } from "styled-components"
import { Script } from "gatsby"

import componentThemeExtension from "utils/componentThemeExtension"

import TextBlock from "components/text-block"
import ContentfulButton from "./button"

const ContentfulTextBlurb = ({
  component,
  nested,
  elRef,
  inGrid = false,
  isPromotionalPlacement,
}) => {
  const scriptString = component.headerScripts?.headerScripts || ""
  const scriptContent = scriptString.replace(/<\/?script>/g, "")

  return (
    <ThemeProvider
      theme={componentThemeExtension(!nested ? component.backgroundColor : null, nested)}
    >
      <React.Suspense>
        {scriptString && <Script id="text-block-header-scripts">{scriptContent}</Script>}
      </React.Suspense>
      <TextBlock
        hideOnPageLoad={component.hideOnPageLoad}
        dataId={component.id}
        id={component.navigationAnchor && component.navigationAnchor.anchorId}
        elRef={elRef}
        text={`${component.text ? component.text.childMarkdownRemark.html : ""}${
          component.customHtml ? component.customHtml.childMarkdownRemark.html : ""
        }`}
        noPadding={!!component.customHtml && !component.text}
        inGrid={inGrid}
        buttonElement={component.button && <ContentfulButton component={component.button} />}
        isPromotionalPlacement={isPromotionalPlacement}
      />
    </ThemeProvider>
  )
}

export default ContentfulTextBlurb
